import { render, staticRenderFns } from "./DaysToShip.vue?vue&type=template&id=1b9bd6d4&"
import script from "./DaysToShip.vue?vue&type=script&lang=js&"
export * from "./DaysToShip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports